import { API_ERROR_TYPES, APIError } from './client';

export const createProfilesAPI = (request) => ({
  getCurrentUser: () => 
    request('/profile-get', {
      method: 'GET'
    }),
    
  updateProfile: ({ profileData, submitted = false }) => {
    if (!profileData || typeof profileData !== 'object' || Array.isArray(profileData)) {
      throw new APIError(
        API_ERROR_TYPES.VALIDATION,
        'Profile data must be an object',
        400
      );
    }

    return request('/profile-update', {
      method: 'PUT',
      body: JSON.stringify({ profileData, submitted })
    });
  },
  
  updateStatus: ({ organization_id, status, organizations }) => {
    // Debug log to see what organizations data we're receiving
    console.log("updateStatus received organizations:", {
      organizations,
      member: organizations?.member || [],
      admin: organizations?.admin || []
    });

    // If organization_id is not provided but organizations is, try to find the accepted organization
    if (!organization_id && organizations) {
      // First check in member organizations
      if (organizations.member) {
        const acceptedMemberOrg = organizations.member.find(org => org.status === 'accepted');
        if (acceptedMemberOrg) {
          organization_id = acceptedMemberOrg.organizationId;
        }
      }
      
      // If not found in member organizations, check in admin organizations
      if (!organization_id && organizations.admin) {
        const acceptedAdminOrg = organizations.admin.find(org => org.status === 'accepted');
        if (acceptedAdminOrg) {
          organization_id = acceptedAdminOrg.organizationId;
        }
      }
    }
    
    if (!organization_id) {
      throw new APIError(
        API_ERROR_TYPES.VALIDATION,
        'No organization with "accepted" status found in your profile',
        400
      );
    }
    
    if (!status || !['active', 'declined'].includes(status)) {
      throw new APIError(
        API_ERROR_TYPES.VALIDATION,
        'Status must be either "active" or "declined"',
        400
      );
    }
    
    return request('/org-profiles-status-update', {
      method: 'PUT',
      body: JSON.stringify({ organization_id, status })
    });
  }
}); 